import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'
import MobileRowWithIconItem from '@mobileShared/MobileRowWithIconItem/MobileRowWithIconItem'
import { useStore } from 'effector-react'
import { $shipment } from '@entities/shipment/model'
import { useToggleAddressSelector, useToggleStockSelector } from 'src/features/shipment-selector/hooks'
import { checkShowedShipmentSearch, updateShowedDateShipmentSearch } from '@services/catalogService'

const ShipmentContainer = styled.div`
    & > a {
        padding: 0.2rem 0.313rem;
        border-bottom: 1px solid ${ThemeColors.getGrayColor(0.2)};
    }

    & > a:last-child {
        border-bottom: 1px solid ${ThemeColors.getGrayColor(0.2)};
    }
`
const ChangeTitle = styled.span`
    font-size: 0.85rem;
    color: ${ThemeColors.getGrayColor(0.5)};
`
const SpanDataItem = styled.span`
    color: ${ThemeColors.getGrayColor(1)};
`

export function ShipmentStateMobile() {
    const shipment = useStore($shipment)
    const [isShowedShipmentState, setIsShowedShipmentState] = useState(false)
    const toggleIsStockSelector = useToggleStockSelector()
    const toggleIsShipAddressSelector = useToggleAddressSelector()

    useEffect(() => {
        const isShowed = checkShowedShipmentSearch()
        setIsShowedShipmentState(isShowed)
        updateShowedDateShipmentSearch()
    }, [])

    if (!isShowedShipmentState) return <React.Fragment />
    return (
        <ShipmentContainer>
            <MobileRowWithIconItem
                aProps={{
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    'data-selected-stock-id': shipment.stockId
                }}
                iconName="geo"
                isShowedRow
                clickHandler={toggleIsStockSelector}>
                <SpanDataItem>{shipment.stockTitle || 'Не выбрана'}</SpanDataItem>
                <ChangeTitle>Выбрать аптеку самовывоза</ChangeTitle>
            </MobileRowWithIconItem>
            <MobileRowWithIconItem
                aProps={{
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    'data-selected-address-id': shipment.shipAddressId
                }}
                iconName="auto"
                isShowedRow
                clickHandler={toggleIsShipAddressSelector}>
                <SpanDataItem>{shipment.shipAddressTitle || 'Не выбран'}</SpanDataItem>
                <ChangeTitle>Изменить адрес доставки</ChangeTitle>
            </MobileRowWithIconItem>
        </ShipmentContainer>
    )
}
